export type AiRecordAction = "startAi" | "stopAi";

export interface AiRecordCommandParams {
  action: AiRecordAction;
  roomId: string;
  conferenceNo?: string;
  peerId?: string;
}

export const AI_RECORD_CHANNEL = "mpchannel";

export function buildAiRecordCommand({
  action,
  roomId,
  conferenceNo = "",
  peerId = "",
}: AiRecordCommandParams) {
  return {
    action,
    command: action,
    roomId,
    conferenceNo,
    peerId,
    data: {
      action,
      roomId,
      conferenceNo,
      peerId,
    },
  };
}
